import gql from "graphql-tag";

export const GET_SmeetzPictures = gql`
  query GET_SmeetzPictures($condition: String!) {
    SmeetzPicture: SmeetzPictureList(where: $condition) {
      id: Id
      metaData: MetaData
      name: Name
      entity: Entity
      entityId: EntityId
    }
  }
`;
